const validate = (values) => {
  const errors = {};
  if (!values.volunteerRole) {
    errors.volunteerRole = "Required";
  }
  return errors;
};

export default validate;
